import { MaterialCommunityIcons } from "@expo/vector-icons";
import React from "react";
import { Pressable, StyleSheet, Text, } from "react-native";
export const Button = ({ buttonText, onPress, disabled, buttonStyle, buttonTextStyle, iconColor, iconName, iconPosition, iconSize = 32, onHoverIn, onHoverOut, }) => {
    return (<Pressable style={({ pressed }) => [
            styles.button,
            disabled && styles.buttonDisabled,
            buttonStyle,
            pressed && { opacity: 0.2 },
        ]} disabled={disabled} onPress={onPress} onHoverIn={onHoverIn} onHoverOut={onHoverOut}>
      {iconName && iconPosition === "left" && (<MaterialCommunityIcons name={iconName} size={iconSize} color={iconColor}/>)}
      {buttonText && (<Text style={[styles.buttonText, buttonTextStyle]}>{buttonText}</Text>)}
      {iconName && iconPosition !== "left" && (<MaterialCommunityIcons name={iconName} size={iconSize} color={iconColor}/>)}
    </Pressable>);
};
const styles = StyleSheet.create({
    button: {
        display: "flex",
        flexDirection: "row",
        gap: 16,
        height: 80,
        minWidth: 80,
        alignItems: "center",
        borderRadius: 40,
        paddingHorizontal: 32,
    },
    buttonText: {
        fontSize: 20,
        lineHeight: 28,
        flexGrow: 1,
    },
    buttonDisabled: {
        opacity: 0.5,
    },
});
//# sourceMappingURL=Button.js.map